'use client';

import { useEffect, useRef } from 'react';
import { clientConfig } from '@/@core/config/client';

export function TurnstileWidget({ onVerify }: { onVerify: (token: string) => void }) {
    const siteKey = clientConfig('turnstile.siteKey');

    const anchorRef = useRef<HTMLDivElement | null>(null);
    const widgetIdRef = useRef<string | null>(null);

    useEffect(() => {
        if (!(window as any).turnstile) {
            const id = 'cf-turnstile-script';
            if (!document.getElementById(id)) {
                const s = document.createElement('script');
                s.id = id;
                s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
                s.async = true;
                s.defer = true;
                s.onload = render;
                document.head.appendChild(s);
            } else {
                const i = setInterval(() => {
                    if ((window as any).turnstile) {
                        clearInterval(i);
                        render();
                    }
                }, 50);
                setTimeout(() => clearInterval(i), 3000);
            }
        } else {
            render();
        }

        return () => {
            try {
                const cf: any = (window as any).turnstile;
                if (cf && widgetIdRef.current) cf.remove(widgetIdRef.current);
            } catch {}
        };
    }, []);

    function render() {
        const cf: any = (window as any).turnstile;
        if (!cf || !anchorRef.current) return;
        if (widgetIdRef.current) {
            try {
                cf.remove(widgetIdRef.current);
            } catch {}
            widgetIdRef.current = null;
        }
        const wid = cf.render(anchorRef.current, {
            sitekey: siteKey,
            appearance: 'always',
            execution: 'render',
            callback: onVerify,
            'error-callback': () => {},
            'expired-callback': () => {},
        });
        widgetIdRef.current = wid;
    }

    return <div ref={anchorRef} id="cf-turnstile-container" />;
}
